//import moment from 'moment'; // Example for onSort prop
//import { NavLink } from 'react-router-dom';

export default [
{
    billno: 1,
    billdate: "11/19/2015",
    patient: "Virginia Rose",
    doctor: "Lawrence Harris",
    charges: 721.00,
    tax: 72.00,
    discount: 36.00,
    total: 757.00
}, {
    billno: 2,
    billdate: "11/20/2015",
    patient: "Julie Lynch",
    doctor: "Nicole Robinson",
    charges: 740.00,
    tax: 74.00,
    discount: 37.00,
    total: 777.00
}, {
    billno: 3,
    billdate: "11/24/2015",
    patient: "Jacqueline Woods",
    doctor: "Cheryl Wells",
    charges: 513.00,
    tax: 51.00,
    discount: 25.00,
    total: 539.00
}, {
    billno: 4,
    billdate: "11/25/2015",
    patient: "Jonathan Lewis",
    doctor: "Terry Stevens",
    charges: 871.00,
    tax: 87.00,
    discount: 43.00,
    total: 915.00
}, {
    billno: 5,
    billdate: "11/22/2015",
    patient: "Benjamin Flores",
    doctor: "Chris Hernandez",
    charges: 636.00,
    tax: 63.00,
    discount: 31.00,
    total: 668.00
}, {
    billno: 6,
    billdate: "11/22/2015",
    patient: "Lori Perkins",
    doctor: "Annie Cooper",
    charges: 637.00,
    tax: 63.00,
    discount: 31.00,
    total: 669.00
}, {
    billno: 7,
    billdate: "11/25/2015",
    patient: "Margaret Griffin",
    doctor: "Jessica Patterson",
    charges: 742.00,
    tax: 74.00,
    discount: 37.00,
    total: 779.00
}, {
    billno: 8,
    billdate: "11/26/2015",
    patient: "Adam Wheeler",
    doctor: "Eugene Nichols",
    charges: 998.00,
    tax: 99.00,
    discount: 49.00,
    total: 1048.00
}, {
    billno: 9,
    billdate: "11/22/2015",
    patient: "Joseph Hunter",
    doctor: "Tammy Gordon",
    charges: 390.00,
    tax: 39.00,
    discount: 19.00,
    total: 410.00
}, {
    billno: 10,
    billdate: "11/26/2015",
    patient: "Fred Taylor",
    doctor: "Kelly Mccoy",
    charges: 343.00,
    tax: 34.00,
    discount: 17.00,
    total: 360.00
}, {
    billno: 11,
    billdate: "11/19/2015",
    patient: "Roger Burke",
    doctor: "Phillip Roberts",
    charges: 293.00,
    tax: 29.00,
    discount: 14.00,
    total: 308.00
}, {
    billno: 12,
    billdate: "11/23/2015",
    patient: "Victor Montgomery",
    doctor: "Kimberly Alexander",
    charges: 334.00,
    tax: 33.00,
    discount: 16.00,
    total: 351.00
}, {
    billno: 13,
    billdate: "11/23/2015",
    patient: "Keith Henry",
    doctor: "Pamela Green",
    charges: 679.00,
    tax: 67.00,
    discount: 33.00,
    total: 713.00
}, {
    billno: 14,
    billdate: "11/23/2015",
    patient: "Betty Willis",
    doctor: "Virginia Collins",
    charges: 716.00,
    tax: 71.00,
    discount: 35.00,
    total: 752.00
}, {
    billno: 15,
    billdate: "11/22/2015",
    patient: "Jack Spencer",
    doctor: "Joseph Carr",
    charges: 213.00,
    tax: 21.00,
    discount: 10.00,
    total: 224.00
}, {
    billno: 16,
    billdate: "11/20/2015",
    patient: "Gloria Kim",
    doctor: "Heather Collins",
    charges: 831.00,
    tax: 83.00,
    discount: 41.00,
    total: 873.00
}, {
    billno: 17,
    billdate: "11/20/2015",
    patient: "Fred Cunningham",
    doctor: "Ryan Kennedy",
    charges: 404.00,
    tax: 40.00,
    discount: 20.00,
    total: 424.00
}, {
    billno: 18,
    billdate: "11/21/2015",
    patient: "Mildred Harper",
    doctor: "Lisa Crawford",
    charges: 116.00,
    tax: 11.00,
    discount: 5.00,
    total: 122.00
}, {
    billno: 19,
    billdate: "11/26/2015",
    patient: "Deborah Robinson",
    doctor: "Phyllis Lawrence",
    charges: 247.00,
    tax: 24.00,
    discount: 12.00,
    total: 259.00
}, {
    billno: 20,
    billdate: "11/20/2015",
    patient: "Eugene Graham",
    doctor: "Christine Ellis",
    charges: 259.00,
    tax: 25.00,
    discount: 12.00,
    total: 272.00
}, {
    billno: 21,
    billdate: "11/26/2015",
    patient: "Raymond Bradley",
    doctor: "Marie Boyd",
    charges: 274.00,
    tax: 27.00,
    discount: 13.00,
    total: 288.00
}, {
    billno: 22,
    billdate: "11/23/2015",
    patient: "Jessica Mendoza",
    doctor: "Wayne Lawson",
    charges: 466.00,
    tax: 46.00,
    discount: 23.00,
    total: 489.00
}, {
    billno: 23,
    billdate: "11/22/2015",
    patient: "Kimberly Cook",
    doctor: "Christina Peterson",
    charges: 459.00,
    tax: 45.00,
    discount: 22.00,
    total: 482.00
}, {
    billno: 24,
    billdate: "11/21/2015",
    patient: "Amanda Johnson",
    doctor: "Edward Hawkins",
    charges: 236.00,
    tax: 23.00,
    discount: 11.00,
    total: 248.00
}, {
    billno: 25,
    billdate: "11/21/2015",
    patient: "Linda Hudson",
    doctor: "Gregory Moore",
    charges: 766.00,
    tax: 76.00,
    discount: 38.00,
    total: 804.00
}, {
    billno: 26,
    billdate: "11/24/2015",
    patient: "Justin Matthews",
    doctor: "Joan Roberts",
    charges: 628.00,
    tax: 62.00,
    discount: 31.00,
    total: 659.00
}, {
    billno: 27,
    billdate: "11/19/2015",
    patient: "Christine Webb",
    doctor: "Edward Peterson",
    charges: 260.00,
    tax: 26.00,
    discount: 13.00,
    total: 273.00
}, {
    billno: 28,
    billdate: "11/19/2015",
    patient: "Billy Torres",
    doctor: "Marilyn Carpenter",
    charges: 250.00,
    tax: 25.00,
    discount: 12.00,
    total: 263.00
}, {
    billno: 29,
    billdate: "11/22/2015",
    patient: "Peter Boyd",
    doctor: "Janice Garza",
    charges: 231.00,
    tax: 23.00,
    discount: 11.00,
    total: 243.00
}, {
    billno: 30,
    billdate: "11/22/2015",
    patient: "Joyce Fields",
    doctor: "Nicholas Davis",
    charges: 449.00,
    tax: 44.00,
    discount: 22.00,
    total: 471.00
}, {
    billno: 31,
    billdate: "11/20/2015",
    patient: "Bonnie Howard",
    doctor: "Louise Hamilton",
    charges: 691.00,
    tax: 69.00,
    discount: 34.00,
    total: 726.00
}, {
    billno: 32,
    billdate: "11/22/2015",
    patient: "Harold Stevens",
    doctor: "Diane Nichols",
    charges: 863.00,
    tax: 86.00,
    discount: 43.00,
    total: 906.00
}, {
    billno: 33,
    billdate: "11/24/2015",
    patient: "Timothy Ramirez",
    doctor: "Kathryn Wheeler",
    charges: 778.00,
    tax: 77.00,
    discount: 38.00,
    total: 817.00
}, {
    billno: 34,
    billdate: "11/24/2015",
    patient: "Sara Barnes",
    doctor: "Kenneth Baker",
    charges: 183.00,
    tax: 18.00,
    discount: 9.00,
    total: 192.00
}, {
    billno: 35,
    billdate: "11/20/2015",
    patient: "Harold Wells",
    doctor: "Sarah Thomas",
    charges: 818.00,
    tax: 81.00,
    discount: 40.00,
    total: 859.00
}, {
    billno: 36,
    billdate: "11/21/2015",
    patient: "Jimmy Holmes",
    doctor: "James Bishop",
    charges: 401.00,
    tax: 40.00,
    discount: 20.00,
    total: 421.00
}, {
    billno: 37,
    billdate: "11/22/2015",
    patient: "Willie Martin",
    doctor: "Alan Mccoy",
    charges: 845.00,
    tax: 84.00,
    discount: 42.00,
    total: 887.00
}, {
    billno: 38,
    billdate: "11/21/2015",
    patient: "Antonio Knight",
    doctor: "Carlos Riley",
    charges: 413.00,
    tax: 41.00,
    discount: 20.00,
    total: 434.00
}, {
    billno: 39,
    billdate: "11/21/2015",
    patient: "Doris Medina",
    doctor: "Annie Sims",
    charges: 797.00,
    tax: 79.00,
    discount: 39.00,
    total: 837.00
}, {
    billno: 40,
    billdate: "11/26/2015",
    patient: "Ashley Gray",
    doctor: "Shawn Armstrong",
    charges: 387.00,
    tax: 38.00,
    discount: 19.00,
    total: 406.00
}, {
    billno: 41,
    billdate: "11/26/2015",
    patient: "Earl Mason",
    doctor: "Elizabeth James",
    charges: 507.00,
    tax: 50.00,
    discount: 25.00,
    total: 532.00
}, {
    billno: 42,
    billdate: "11/20/2015",
    patient: "Adam Andrews",
    doctor: "Mildred Spencer",
    charges: 234.00,
    tax: 23.00,
    discount: 11.00,
    total: 246.00
}, {
    billno: 43,
    billdate: "11/23/2015",
    patient: "Randy Cox",
    doctor: "Marilyn Ellis",
    charges: 864.00,
    tax: 86.00,
    discount: 43.00,
    total: 907.00
}, {
    billno: 44,
    billdate: "11/22/2015",
    patient: "Sandra Hudson",
    doctor: "Justin Adams",
    charges: 457.00,
    tax: 45.00,
    discount: 22.00,
    total: 480.00
}, {
    billno: 45,
    billdate: "11/25/2015",
    patient: "Andrea Diaz",
    doctor: "Raymond Lawson",
    charges: 864.00,
    tax: 86.00,
    discount: 43.00,
    total: 907.00
}, {
    billno: 46,
    billdate: "11/23/2015",
    patient: "Diana Ray",
    doctor: "Roy Rose",
    charges: 512.00,
    tax: 51.00,
    discount: 25.00,
    total: 538.00
}, {
    billno: 47,
    billdate: "11/20/2015",
    patient: "Craig Howell",
    doctor: "Barbara Martinez",
    charges: 909.00,
    tax: 90.00,
    discount: 45.00,
    total: 954.00
}, {
    billno: 48,
    billdate: "11/21/2015",
    patient: "Nicholas Hunt",
    doctor: "Louise Henderson",
    charges: 496.00,
    tax: 49.00,
    discount: 24.00,
    total: 521.00
}, {
    billno: 49,
    billdate: "11/21/2015",
    patient: "Steve Simpson",
    doctor: "Jonathan Brooks",
    charges: 240.00,
    tax: 24.00,
    discount: 12.00,
    total: 252.00
}, {
    billno: 50,
    billdate: "11/25/2015",
    patient: "Elizabeth Martinez",
    doctor: "Betty Lynch",
    charges: 412.00,
    tax: 41.00,
    discount: 20.00,
    total: 433.00
}, {
    billno: 51,
    billdate: "11/20/2015",
    patient: "Pamela Harvey",
    doctor: "Denise Washington",
    charges: 739.00,
    tax: 73.00,
    discount: 36.00,
    total: 776.00
}, {
    billno: 52,
    billdate: "11/26/2015",
    patient: "Sharon Carpenter",
    doctor: "Joshua Clark",
    charges: 392.00,
    tax: 39.00,
    discount: 19.00,
    total: 412.00
}, {
    billno: 53,
    billdate: "11/21/2015",
    patient: "Wayne Lane",
    doctor: "Juan Hernandez",
    charges: 653.00,
    tax: 65.00,
    discount: 32.00,
    total: 686.00
}, {
    billno: 54,
    billdate: "11/22/2015",
    patient: "Bonnie George",
    doctor: "Kathleen Sanchez",
    charges: 250.00,
    tax: 25.00,
    discount: 12.00,
    total: 263.00
}, {
    billno: 55,
    billdate: "11/19/2015",
    patient: "Jessica Taylor",
    doctor: "Jimmy Montgomery",
    charges: 952.00,
    tax: 95.00,
    discount: 47.00,
    total: 1000.00
}, {
    billno: 56,
    billdate: "11/24/2015",
    patient: "Deborah Mitchell",
    doctor: "James Montgomery",
    charges: 979.00,
    tax: 97.00,
    discount: 48.00,
    total: 1028.00
}, {
    billno: 57,
    billdate: "11/22/2015",
    patient: "Roger Coleman",
    doctor: "Christine Perkins",
    charges: 820.00,
    tax: 82.00,
    discount: 41.00,
    total: 861.00
}, {
    billno: 58,
    billdate: "11/20/2015",
    patient: "Fred Jones",
    doctor: "Nicole Lee",
    charges: 683.00,
    tax: 68.00,
    discount: 34.00,
    total: 717.00
}, {
    billno: 59,
    billdate: "11/21/2015",
    patient: "Willie Collins",
    doctor: "John Willis",
    charges: 341.00,
    tax: 34.00,
    discount: 17.00,
    total: 358.00
}, {
    billno: 60,
    billdate: "11/19/2015",
    patient: "Karen Dean",
    doctor: "Judy Edwards",
    charges: 843.00,
    tax: 84.00,
    discount: 42.00,
    total: 885.00
}, {
    billno: 61,
    billdate: "11/26/2015",
    patient: "Frank Porter",
    doctor: "Jimmy Stanley",
    charges: 793.00,
    tax: 79.00,
    discount: 39.00,
    total: 833.00
}, {
    billno: 62,
    billdate: "11/25/2015",
    patient: "Rachel Crawford",
    doctor: "Lisa Ryan",
    charges: 137.00,
    tax: 13.00,
    discount: 6.00,
    total: 144.00
}, {
    billno: 63,
    billdate: "11/23/2015",
    patient: "Betty Palmer",
    doctor: "Lois Myers",
    charges: 285.00,
    tax: 28.00,
    discount: 14.00,
    total: 299.00
}, {
    billno: 64,
    billdate: "11/19/2015",
    patient: "Lisa Gutierrez",
    doctor: "Carl Ramirez",
    charges: 133.00,
    tax: 13.00,
    discount: 6.00,
    total: 140.00
}, {
    billno: 65,
    billdate: "11/23/2015",
    patient: "Lori Austin",
    doctor: "Lawrence Fuller",
    charges: 871.00,
    tax: 87.00,
    discount: 43.00,
    total: 915.00
}, {
    billno: 66,
    billdate: "11/22/2015",
    patient: "Brandon Fields",
    doctor: "Martin Coleman",
    charges: 834.00,
    tax: 83.00,
    discount: 41.00,
    total: 876.00
}, {
    billno: 67,
    billdate: "11/24/2015",
    patient: "Thomas Sullivan",
    doctor: "Alice Bennett",
    charges: 545.00,
    tax: 54.00,
    discount: 27.00,
    total: 572.00
}, {
    billno: 68,
    billdate: "11/19/2015",
    patient: "Ralph Hanson",
    doctor: "Ronald Allen",
    charges: 603.00,
    tax: 60.00,
    discount: 30.00,
    total: 633.00
}, {
    billno: 69,
    billdate: "11/22/2015",
    patient: "Melissa Henry",
    doctor: "Edward Bailey",
    charges: 621.00,
    tax: 62.00,
    discount: 31.00,
    total: 652.00
}, {
    billno: 70,
    billdate: "11/23/2015",
    patient: "Stephen Barnes",
    doctor: "Janice Marshall",
    charges: 444.00,
    tax: 44.00,
    discount: 22.00,
    total: 466.00
}, {
    billno: 71,
    billdate: "11/20/2015",
    patient: "Willie Stewart",
    doctor: "Phyllis Wells",
    charges: 809.00,
    tax: 80.00,
    discount: 40.00,
    total: 849.00
}, {
    billno: 72,
    billdate: "11/21/2015",
    patient: "Christina Anderson",
    doctor: "Melissa Coleman",
    charges: 736.00,
    tax: 73.00,
    discount: 36.00,
    total: 773.00
}, {
    billno: 73,
    billdate: "11/22/2015",
    patient: "Craig Alexander",
    doctor: "Philip Gonzalez",
    charges: 711.00,
    tax: 71.00,
    discount: 35.00,
    total: 747.00
}, {
    billno: 74,
    billdate: "11/22/2015",
    patient: "David Williamson",
    doctor: "Carolyn Morris",
    charges: 129.00,
    tax: 12.00,
    discount: 6.00,
    total: 135.00
}, {
    billno: 75,
    billdate: "11/24/2015",
    patient: "Clarence Johnson",
    doctor: "Edward Dunn",
    charges: 747.00,
    tax: 74.00,
    discount: 37.00,
    total: 784.00
}, {
    billno: 76,
    billdate: "11/25/2015",
    patient: "Heather Rose",
    doctor: "Benjamin Castillo",
    charges: 725.00,
    tax: 72.00,
    discount: 36.00,
    total: 761.00
}, {
    billno: 77,
    billdate: "11/24/2015",
    patient: "Randy Murphy",
    doctor: "Judith Castillo",
    charges: 760.00,
    tax: 76.00,
    discount: 38.00,
    total: 798.00
}, {
    billno: 78,
    billdate: "11/23/2015",
    patient: "Andrea Jenkins",
    doctor: "Julia Coleman",
    charges: 354.00,
    tax: 35.00,
    discount: 17.00,
    total: 372.00
}, {
    billno: 79,
    billdate: "11/25/2015",
    patient: "Carlos Flores",
    doctor: "Beverly Garza",
    charges: 922.00,
    tax: 92.00,
    discount: 46.00,
    total: 968.00
}, {
    billno: 80,
    billdate: "11/22/2015",
    patient: "Joan Wright",
    doctor: "Catherine Sullivan",
    charges: 639.00,
    tax: 63.00,
    discount: 31.00,
    total: 671.00
}, {
    billno: 81,
    billdate: "11/24/2015",
    patient: "Brenda Ramirez",
    doctor: "Tina Ortiz",
    charges: 982.00,
    tax: 98.00,
    discount: 49.00,
    total: 1031.00
}, {
    billno: 82,
    billdate: "11/24/2015",
    patient: "Kimberly Roberts",
    doctor: "Larry Sims",
    charges: 701.00,
    tax: 70.00,
    discount: 35.00,
    total: 736.00
}, {
    billno: 83,
    billdate: "11/20/2015",
    patient: "Ralph Scott",
    doctor: "Julie Mccoy",
    charges: 154.00,
    tax: 15.00,
    discount: 7.00,
    total: 162.00
}, {
    billno: 84,
    billdate: "11/23/2015",
    patient: "Jerry Wallace",
    doctor: "Jose Dean",
    charges: 538.00,
    tax: 53.00,
    discount: 26.00,
    total: 565.00
}, {
    billno: 85,
    billdate: "11/22/2015",
    patient: "David Reed",
    doctor: "Roger Rice",
    charges: 665.00,
    tax: 66.00,
    discount: 33.00,
    total: 698.00
}, {
    billno: 86,
    billdate: "11/20/2015",
    patient: "Jerry Fernandez",
    doctor: "Julia Rose",
    charges: 688.00,
    tax: 68.00,
    discount: 34.00,
    total: 722.00
}, {
    billno: 87,
    billdate: "11/20/2015",
    patient: "Phillip Bailey",
    doctor: "Anne Harrison",
    charges: 332.00,
    tax: 33.00,
    discount: 16.00,
    total: 349.00
}, {
    billno: 88,
    billdate: "11/22/2015",
    patient: "Susan Foster",
    doctor: "Jessica Brown",
    charges: 722.00,
    tax: 72.00,
    discount: 36.00,
    total: 758.00
}, {
    billno: 89,
    billdate: "11/26/2015",
    patient: "Anne Gordon",
    doctor: "Betty Franklin",
    charges: 520.00,
    tax: 52.00,
    discount: 26.00,
    total: 546.00
}, {
    billno: 90,
    billdate: "11/19/2015",
    patient: "Joseph Ward",
    doctor: "Kimberly Dixon",
    charges: 378.00,
    tax: 37.00,
    discount: 18.00,
    total: 397.00
}, {
    billno: 91,
    billdate: "11/19/2015",
    patient: "Jacqueline Diaz",
    doctor: "Brian Brown",
    charges: 500.00,
    tax: 50.00,
    discount: 25.00,
    total: 525.00
}, {
    billno: 92,
    billdate: "11/20/2015",
    patient: "Angela Mitchell",
    doctor: "Teresa Miller",
    charges: 942.00,
    tax: 94.00,
    discount: 47.00,
    total: 989.00
}, {
    billno: 93,
    billdate: "11/23/2015",
    patient: "Victor Brooks",
    doctor: "Mark Welch",
    charges: 289.00,
    tax: 28.00,
    discount: 14.00,
    total: 303.00
}, {
    billno: 94,
    billdate: "11/21/2015",
    patient: "Kevin West",
    doctor: "Andrea Foster",
    charges: 511.00,
    tax: 51.00,
    discount: 25.00,
    total: 537.00
}, {
    billno: 95,
    billdate: "11/20/2015",
    patient: "Earl Cook",
    doctor: "Sean Rice",
    charges: 340.00,
    tax: 34.00,
    discount: 17.00,
    total: 357.00
}, {
    billno: 96,
    billdate: "11/25/2015",
    patient: "Anthony Stone",
    doctor: "Harold Hanson",
    charges: 565.00,
    tax: 56.00,
    discount: 28.00,
    total: 593.00
}, {
    billno: 97,
    billdate: "11/19/2015",
    patient: "Tina Payne",
    doctor: "Bruce Bailey",
    charges: 359.00,
    tax: 35.00,
    discount: 17.00,
    total: 377.00
}, {
    billno: 98,
    billdate: "11/20/2015",
    patient: "Karen Cunningham",
    doctor: "George Bowman",
    charges: 180.00,
    tax: 18.00,
    discount: 9.00,
    total: 189.00
}, {
    billno: 99,
    billdate: "11/24/2015",
    patient: "George Shaw",
    doctor: "Judy Morrison",
    charges: 136.00,
    tax: 13.00,
    discount: 6.00,
    total: 143.00
}, {
    billno: 100,
    billdate: "11/26/2015",
    patient: "Doris Carr",
    doctor: "Christina Graham",
    charges: 499.00,
    tax: 49.00,
    discount: 24.00,
    total: 524.00
}, {
    billno: 101,
    billdate: "11/26/2015",
    patient: "Denise Jackson",
    doctor: "Frank Moore",
    charges: 336.00,
    tax: 33.00,
    discount: 16.00,
    total: 353.00
}, {
    billno: 102,
    billdate: "11/21/2015",
    patient: "Evelyn Collins",
    doctor: "Kathy Riley",
    charges: 227.00,
    tax: 22.00,
    discount: 11.00,
    total: 238.00
}, {
    billno: 103,
    billdate: "11/25/2015",
    patient: "Ann Wagner",
    doctor: "Sarah Reid",
    charges: 116.00,
    tax: 11.00,
    discount: 5.00,
    total: 122.00
}, {
    billno: 104,
    billdate: "11/22/2015",
    patient: "Sharon Edwards",
    doctor: "Louise Watson",
    charges: 236.00,
    tax: 23.00,
    discount: 11.00,
    total: 248.00
}, {
    billno: 105,
    billdate: "11/21/2015",
    patient: "Christina Thomas",
    doctor: "Juan Freeman",
    charges: 104.00,
    tax: 10.00,
    discount: 5.00,
    total: 109.00
}, {
    billno: 106,
    billdate: "11/21/2015",
    patient: "Bruce Morris",
    doctor: "Arthur Mitchell",
    charges: 792.00,
    tax: 79.00,
    discount: 39.00,
    total: 832.00
}, {
    billno: 107,
    billdate: "11/25/2015",
    patient: "Sara Martinez",
    doctor: "Shirley Turner",
    charges: 977.00,
    tax: 97.00,
    discount: 48.00,
    total: 1026.00
}, {
    billno: 108,
    billdate: "11/21/2015",
    patient: "Eric Sanchez",
    doctor: "Margaret Walker",
    charges: 564.00,
    tax: 56.00,
    discount: 28.00,
    total: 592.00
}, {
    billno: 109,
    billdate: "11/23/2015",
    patient: "Julie Payne",
    doctor: "Rebecca Smith",
    charges: 774.00,
    tax: 77.00,
    discount: 38.00,
    total: 813.00
}, {
    billno: 110,
    billdate: "11/26/2015",
    patient: "Peter Elliott",
    doctor: "Ruby Matthews",
    charges: 871.00,
    tax: 87.00,
    discount: 43.00,
    total: 915.00
}, {
    billno: 111,
    billdate: "11/23/2015",
    patient: "Robin Gray",
    doctor: "Karen Henry",
    charges: 935.00,
    tax: 93.00,
    discount: 46.00,
    total: 982.00
}, {
    billno: 112,
    billdate: "11/19/2015",
    patient: "Sharon Chapman",
    doctor: "Gary Jenkins",
    charges: 198.00,
    tax: 19.00,
    discount: 9.00,
    total: 208.00
}, {
    billno: 113,
    billdate: "11/20/2015",
    patient: "Angela Stewart",
    doctor: "Heather Butler",
    charges: 694.00,
    tax: 69.00,
    discount: 34.00,
    total: 729.00
}, {
    billno: 114,
    billdate: "11/22/2015",
    patient: "Rose Hicks",
    doctor: "Henry Fowler",
    charges: 387.00,
    tax: 38.00,
    discount: 19.00,
    total: 406.00
}, {
    billno: 115,
    billdate: "11/20/2015",
    patient: "Theresa White",
    doctor: "Rachel Allen",
    charges: 412.00,
    tax: 41.00,
    discount: 20.00,
    total: 433.00
}, {
    billno: 116,
    billdate: "11/19/2015",
    patient: "Elizabeth Ryan",
    doctor: "Russell Simpson",
    charges: 260.00,
    tax: 26.00,
    discount: 13.00,
    total: 273.00
}, {
    billno: 117,
    billdate: "11/20/2015",
    patient: "Aaron Smith",
    doctor: "Patricia Spencer",
    charges: 870.00,
    tax: 87.00,
    discount: 43.00,
    total: 914.00
}, {
    billno: 118,
    billdate: "11/23/2015",
    patient: "Donald Myers",
    doctor: "Melissa Baker",
    charges: 508.00,
    tax: 50.00,
    discount: 25.00,
    total: 533.00
}, {
    billno: 119,
    billdate: "11/25/2015",
    patient: "Frances Hill",
    doctor: "Rachel Harper",
    charges: 508.00,
    tax: 50.00,
    discount: 25.00,
    total: 533.00
}, {
    billno: 120,
    billdate: "11/26/2015",
    patient: "Doris Johnson",
    doctor: "Jennifer Gomez",
    charges: 604.00,
    tax: 60.00,
    discount: 30.00,
    total: 634.00
}, {
    billno: 121,
    billdate: "11/19/2015",
    patient: "Stephanie Anderson",
    doctor: "Joe Gutierrez",
    charges: 739.00,
    tax: 73.00,
    discount: 36.00,
    total: 776.00
}, {
    billno: 122,
    billdate: "11/20/2015",
    patient: "Henry Nichols",
    doctor: "Teresa Foster",
    charges: 252.00,
    tax: 25.00,
    discount: 12.00,
    total: 265.00
}, {
    billno: 123,
    billdate: "11/20/2015",
    patient: "Ralph Allen",
    doctor: "Kevin Allen",
    charges: 131.00,
    tax: 13.00,
    discount: 6.00,
    total: 138.00
}, {
    billno: 124,
    billdate: "11/26/2015",
    patient: "Philip Hunt",
    doctor: "Lisa Lawson",
    charges: 696.00,
    tax: 69.00,
    discount: 34.00,
    total: 731.00
}, {
    billno: 125,
    billdate: "11/19/2015",
    patient: "Beverly Lynch",
    doctor: "Theresa Scott",
    charges: 630.00,
    tax: 63.00,
    discount: 31.00,
    total: 662.00
}, {
    billno: 126,
    billdate: "11/23/2015",
    patient: "Michael Hart",
    doctor: "Joshua Simmons",
    charges: 594.00,
    tax: 59.00,
    discount: 29.00,
    total: 624.00
}, {
    billno: 127,
    billdate: "11/24/2015",
    patient: "Margaret Schmidt",
    doctor: "Douglas Moreno",
    charges: 758.00,
    tax: 75.00,
    discount: 37.00,
    total: 796.00
}, {
    billno: 128,
    billdate: "11/23/2015",
    patient: "Sandra Collins",
    doctor: "Julie Lee",
    charges: 985.00,
    tax: 98.00,
    discount: 49.00,
    total: 1034.00
}, {
    billno: 129,
    billdate: "11/20/2015",
    patient: "Kathleen West",
    doctor: "Louis Alvarez",
    charges: 995.00,
    tax: 99.00,
    discount: 49.00,
    total: 1045.00
}, {
    billno: 130,
    billdate: "11/26/2015",
    patient: "Theresa Ellis",
    doctor: "Timothy Martin",
    charges: 411.00,
    tax: 41.00,
    discount: 20.00,
    total: 432.00
}, {
    billno: 131,
    billdate: "11/19/2015",
    patient: "Harry Flores",
    doctor: "Beverly Patterson",
    charges: 724.00,
    tax: 72.00,
    discount: 36.00,
    total: 760.00
}, {
    billno: 132,
    billdate: "11/26/2015",
    patient: "Gloria Weaver",
    doctor: "Douglas Hicks",
    charges: 584.00,
    tax: 58.00,
    discount: 29.00,
    total: 613.00
}, {
    billno: 133,
    billdate: "11/19/2015",
    patient: "Brandon Bowman",
    doctor: "Lori Medina",
    charges: 629.00,
    tax: 62.00,
    discount: 31.00,
    total: 660.00
}, {
    billno: 134,
    billdate: "11/26/2015",
    patient: "Louise Peters",
    doctor: "Sandra Gomez",
    charges: 476.00,
    tax: 47.00,
    discount: 23.00,
    total: 500.00
}, {
    billno: 135,
    billdate: "11/26/2015",
    patient: "Jeremy Mitchell",
    doctor: "Steve Burns",
    charges: 682.00,
    tax: 68.00,
    discount: 34.00,
    total: 716.00
}, {
    billno: 136,
    billdate: "11/20/2015",
    patient: "Ann Cook",
    doctor: "Roy Holmes",
    charges: 375.00,
    tax: 37.00,
    discount: 18.00,
    total: 394.00
}, {
    billno: 137,
    billdate: "11/25/2015",
    patient: "Robin Perez",
    doctor: "Helen Lane",
    charges: 944.00,
    tax: 94.00,
    discount: 47.00,
    total: 991.00
}, {
    billno: 138,
    billdate: "11/21/2015",
    patient: "Wanda Richards",
    doctor: "Bonnie Williamson",
    charges: 747.00,
    tax: 74.00,
    discount: 37.00,
    total: 784.00
}, {
    billno: 139,
    billdate: "11/20/2015",
    patient: "Nicole Lee",
    doctor: "Ronald Allen",
    charges: 355.00,
    tax: 35.00,
    discount: 17.00,
    total: 373.00
}, {
    billno: 140,
    billdate: "11/20/2015",
    patient: "Debra Day",
    doctor: "Kenneth Clark",
    charges: 963.00,
    tax: 96.00,
    discount: 48.00,
    total: 1011.00
}, {
    billno: 141,
    billdate: "11/22/2015",
    patient: "Rose Peterson",
    doctor: "Joseph Fernandez",
    charges: 867.00,
    tax: 86.00,
    discount: 43.00,
    total: 910.00
}, {
    billno: 142,
    billdate: "11/20/2015",
    patient: "Brenda Russell",
    doctor: "Jerry Crawford",
    charges: 756.00,
    tax: 75.00,
    discount: 37.00,
    total: 794.00
}, {
    billno: 143,
    billdate: "11/23/2015",
    patient: "Thomas Sims",
    doctor: "Norma Butler",
    charges: 346.00,
    tax: 34.00,
    discount: 17.00,
    total: 363.00
}, {
    billno: 144,
    billdate: "11/22/2015",
    patient: "Benjamin Fowler",
    doctor: "Brandon Dixon",
    charges: 910.00,
    tax: 91.00,
    discount: 45.00,
    total: 956.00
}, {
    billno: 145,
    billdate: "11/25/2015",
    patient: "Donna Watson",
    doctor: "Rachel Riley",
    charges: 721.00,
    tax: 72.00,
    discount: 36.00,
    total: 757.00
}, {
    billno: 146,
    billdate: "11/19/2015",
    patient: "Jennifer Perkins",
    doctor: "Marilyn Willis",
    charges: 456.00,
    tax: 45.00,
    discount: 22.00,
    total: 479.00
}, {
    billno: 147,
    billdate: "11/25/2015",
    patient: "Bruce Miller",
    doctor: "George Cox",
    charges: 644.00,
    tax: 64.00,
    discount: 32.00,
    total: 676.00
}, {
    billno: 148,
    billdate: "11/22/2015",
    patient: "Patrick Ruiz",
    doctor: "Juan Mills",
    charges: 767.00,
    tax: 76.00,
    discount: 38.00,
    total: 805.00
}, {
    billno: 149,
    billdate: "11/21/2015",
    patient: "Todd Oliver",
    doctor: "Alice Cooper",
    charges: 512.00,
    tax: 51.00,
    discount: 25.00,
    total: 538.00
}, {
    billno: 150,
    billdate: "11/26/2015",
    patient: "Gloria Mason",
    doctor: "Rachel Wood",
    charges: 648.00,
    tax: 64.00,
    discount: 32.00,
    total: 680.00
}, {
    billno: 151,
    billdate: "11/21/2015",
    patient: "Jean Jones",
    doctor: "Anthony Knight",
    charges: 828.00,
    tax: 82.00,
    discount: 41.00,
    total: 869.00
}, {
    billno: 152,
    billdate: "11/25/2015",
    patient: "Gary Welch",
    doctor: "Lori Owens",
    charges: 510.00,
    tax: 51.00,
    discount: 25.00,
    total: 536.00
}, {
    billno: 153,
    billdate: "11/23/2015",
    patient: "Diana Garza",
    doctor: "Russell Carr",
    charges: 434.00,
    tax: 43.00,
    discount: 21.00,
    total: 456.00
}, {
    billno: 154,
    billdate: "11/22/2015",
    patient: "Maria Fields",
    doctor: "Jimmy Young",
    charges: 714.00,
    tax: 71.00,
    discount: 35.00,
    total: 750.00
}, {
    billno: 155,
    billdate: "11/23/2015",
    patient: "Margaret Cunningham",
    doctor: "Theresa Vasquez",
    charges: 844.00,
    tax: 84.00,
    discount: 42.00,
    total: 886.00
}, {
    billno: 156,
    billdate: "11/25/2015",
    patient: "Shawn King",
    doctor: "Scott Matthews",
    charges: 860.00,
    tax: 86.00,
    discount: 43.00,
    total: 903.00
}, {
    billno: 157,
    billdate: "11/20/2015",
    patient: "Susan Willis",
    doctor: "Kimberly Lewis",
    charges: 970.00,
    tax: 97.00,
    discount: 48.00,
    total: 1019.00
}, {
    billno: 158,
    billdate: "11/25/2015",
    patient: "Mary Schmidt",
    doctor: "Keith Reyes",
    charges: 256.00,
    tax: 25.00,
    discount: 12.00,
    total: 269.00
}, {
    billno: 159,
    billdate: "11/20/2015",
    patient: "Peter Webb",
    doctor: "Louis Peters",
    charges: 713.00,
    tax: 71.00,
    discount: 35.00,
    total: 749.00
}, {
    billno: 160,
    billdate: "11/19/2015",
    patient: "Teresa Wheeler",
    doctor: "Harry Diaz",
    charges: 499.00,
    tax: 49.00,
    discount: 24.00,
    total: 524.00
}, {
    billno: 161,
    billdate: "11/26/2015",
    patient: "Gary George",
    doctor: "Todd King",
    charges: 623.00,
    tax: 62.00,
    discount: 31.00,
    total: 654.00
}, {
    billno: 162,
    billdate: "11/25/2015",
    patient: "Cheryl Jones",
    doctor: "Emily Carroll",
    charges: 895.00,
    tax: 89.00,
    discount: 44.00,
    total: 940.00
}, {
    billno: 163,
    billdate: "11/24/2015",
    patient: "Randy Carpenter",
    doctor: "Kelly Castillo",
    charges: 175.00,
    tax: 17.00,
    discount: 8.00,
    total: 184.00
}, {
    billno: 164,
    billdate: "11/23/2015",
    patient: "Jason Frazier",
    doctor: "Jack Rodriguez",
    charges: 240.00,
    tax: 24.00,
    discount: 12.00,
    total: 252.00
}, {
    billno: 165,
    billdate: "11/26/2015",
    patient: "Edward Peters",
    doctor: "Emily Lopez",
    charges: 750.00,
    tax: 75.00,
    discount: 37.00,
    total: 788.00
}, {
    billno: 166,
    billdate: "11/23/2015",
    patient: "Chris Gardner",
    doctor: "Shawn Porter",
    charges: 140.00,
    tax: 14.00,
    discount: 7.00,
    total: 147.00
}, {
    billno: 167,
    billdate: "11/23/2015",
    patient: "Michelle Nichols",
    doctor: "Randy Scott",
    charges: 170.00,
    tax: 17.00,
    discount: 8.00,
    total: 179.00
}, {
    billno: 168,
    billdate: "11/22/2015",
    patient: "Benjamin Rogers",
    doctor: "Patrick Simmons",
    charges: 527.00,
    tax: 52.00,
    discount: 26.00,
    total: 553.00
}, {
    billno: 169,
    billdate: "11/26/2015",
    patient: "Ralph Hanson",
    doctor: "Wanda Welch",
    charges: 188.00,
    tax: 18.00,
    discount: 9.00,
    total: 197.00
}, {
    billno: 170,
    billdate: "11/22/2015",
    patient: "Aaron Tucker",
    doctor: "Deborah Watkins",
    charges: 500.00,
    tax: 50.00,
    discount: 25.00,
    total: 525.00
}, {
    billno: 171,
    billdate: "11/21/2015",
    patient: "Christopher Kim",
    doctor: "Charles Garcia",
    charges: 147.00,
    tax: 14.00,
    discount: 7.00,
    total: 154.00
}, {
    billno: 172,
    billdate: "11/23/2015",
    patient: "Joshua Campbell",
    doctor: "Edward Tucker",
    charges: 490.00,
    tax: 49.00,
    discount: 24.00,
    total: 515.00
}, {
    billno: 173,
    billdate: "11/24/2015",
    patient: "Bonnie Porter",
    doctor: "Billy Gutierrez",
    charges: 508.00,
    tax: 50.00,
    discount: 25.00,
    total: 533.00
}, {
    billno: 174,
    billdate: "11/26/2015",
    patient: "David Ellis",
    doctor: "Denise Foster",
    charges: 628.00,
    tax: 62.00,
    discount: 31.00,
    total: 659.00
}, {
    billno: 175,
    billdate: "11/22/2015",
    patient: "Kathryn Spencer",
    doctor: "Tammy Willis",
    charges: 425.00,
    tax: 42.00,
    discount: 21.00,
    total: 446.00
}, {
    billno: 176,
    billdate: "11/23/2015",
    patient: "Julia Fields",
    doctor: "Rose Thompson",
    charges: 137.00,
    tax: 13.00,
    discount: 6.00,
    total: 144.00
}, {
    billno: 177,
    billdate: "11/21/2015",
    patient: "Kathleen Cruz",
    doctor: "Ryan Roberts",
    charges: 264.00,
    tax: 26.00,
    discount: 13.00,
    total: 277.00
}, {
    billno: 178,
    billdate: "11/20/2015",
    patient: "Scott Foster",
    doctor: "Judith Berry",
    charges: 884.00,
    tax: 88.00,
    discount: 44.00,
    total: 928.00
}, {
    billno: 179,
    billdate: "11/25/2015",
    patient: "Gerald Long",
    doctor: "Lawrence Medina",
    charges: 881.00,
    tax: 88.00,
    discount: 44.00,
    total: 925.00
}, {
    billno: 180,
    billdate: "11/26/2015",
    patient: "Kenneth Ford",
    doctor: "Evelyn Gonzalez",
    charges: 175.00,
    tax: 17.00,
    discount: 8.00,
    total: 184.00
}, {
    billno: 181,
    billdate: "11/20/2015",
    patient: "Elizabeth George",
    doctor: "Edward Fields",
    charges: 623.00,
    tax: 62.00,
    discount: 31.00,
    total: 654.00
}, {
    billno: 182,
    billdate: "11/19/2015",
    patient: "Carol Stewart",
    doctor: "Steve Boyd",
    charges: 864.00,
    tax: 86.00,
    discount: 43.00,
    total: 907.00
}, {
    billno: 183,
    billdate: "11/20/2015",
    patient: "Scott Hall",
    doctor: "Joseph Baker",
    charges: 913.00,
    tax: 91.00,
    discount: 45.00,
    total: 959.00
}, {
    billno: 184,
    billdate: "11/26/2015",
    patient: "Ernest Elliott",
    doctor: "Randy Reed",
    charges: 204.00,
    tax: 20.00,
    discount: 10.00,
    total: 214.00
}, {
    billno: 185,
    billdate: "11/23/2015",
    patient: "Samuel Porter",
    doctor: "Michael Collins",
    charges: 634.00,
    tax: 63.00,
    discount: 31.00,
    total: 666.00
}, {
    billno: 186,
    billdate: "11/24/2015",
    patient: "Angela Chavez",
    doctor: "Jimmy Watson",
    charges: 653.00,
    tax: 65.00,
    discount: 32.00,
    total: 686.00
}, {
    billno: 187,
    billdate: "11/22/2015",
    patient: "Catherine Ortiz",
    doctor: "Bonnie Warren",
    charges: 320.00,
    tax: 32.00,
    discount: 16.00,
    total: 336.00
}, {
    billno: 188,
    billdate: "11/24/2015",
    patient: "Thomas Lee",
    doctor: "Judy Welch",
    charges: 950.00,
    tax: 95.00,
    discount: 47.00,
    total: 998.00
}, {
    billno: 189,
    billdate: "11/21/2015",
    patient: "Norma Daniels",
    doctor: "Paul Ferguson",
    charges: 472.00,
    tax: 47.00,
    discount: 23.00,
    total: 496.00
}, {
    billno: 190,
    billdate: "11/21/2015",
    patient: "Steve Gilbert",
    doctor: "Walter Porter",
    charges: 662.00,
    tax: 66.00,
    discount: 33.00,
    total: 695.00
}, {
    billno: 191,
    billdate: "11/26/2015",
    patient: "Fred Russell",
    doctor: "Jimmy Porter",
    charges: 417.00,
    tax: 41.00,
    discount: 20.00,
    total: 438.00
}, {
    billno: 192,
    billdate: "11/20/2015",
    patient: "Michael Lopez",
    doctor: "Pamela Montgomery",
    charges: 610.00,
    tax: 61.00,
    discount: 30.00,
    total: 641.00
}, {
    billno: 193,
    billdate: "11/26/2015",
    patient: "Peter Fisher",
    doctor: "Ralph Dean",
    charges: 429.00,
    tax: 42.00,
    discount: 21.00,
    total: 450.00
}, {
    billno: 194,
    billdate: "11/24/2015",
    patient: "Eugene Morris",
    doctor: "Beverly Hayes",
    charges: 126.00,
    tax: 12.00,
    discount: 6.00,
    total: 132.00
}, {
    billno: 195,
    billdate: "11/25/2015",
    patient: "Heather Fuller",
    doctor: "Kathy Stone",
    charges: 491.00,
    tax: 49.00,
    discount: 24.00,
    total: 516.00
}, {
    billno: 196,
    billdate: "11/21/2015",
    patient: "Andrea Robinson",
    doctor: "Frank Gomez",
    charges: 854.00,
    tax: 85.00,
    discount: 42.00,
    total: 897.00
}, {
    billno: 197,
    billdate: "11/19/2015",
    patient: "Benjamin Dixon",
    doctor: "Gregory Gordon",
    charges: 933.00,
    tax: 93.00,
    discount: 46.00,
    total: 980.00
}, {
    billno: 198,
    billdate: "11/22/2015",
    patient: "Angela Torres",
    doctor: "Ruth Jackson",
    charges: 630.00,
    tax: 63.00,
    discount: 31.00,
    total: 662.00
}, {
    billno: 199,
    billdate: "11/26/2015",
    patient: "Ryan Ford",
    doctor: "Marie Kim",
    charges: 524.00,
    tax: 52.00,
    discount: 26.00,
    total: 550.00
}, {
    billno: 200,
    billdate: "11/23/2015",
    patient: "Paul Gardner",
    doctor: "Philip Robertson",
    charges: 341.00,
    tax: 34.00,
    discount: 17.00,
    total: 358
}
]